import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';
import { ConsumeService } from './consume.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(private consume: ConsumeService) {}

  encryptData(data: any, encode: boolean) {
    return encode ? encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data), environment.passEncode).toString()) : CryptoJS.AES.encrypt(JSON.stringify(data), environment.passEncode).toString();
  }

  decryptData(data: any) {
    const decode = decodeURIComponent(data);
    const bytes = CryptoJS.AES.decrypt(decode, environment.passEncode);
    if (bytes.toString()) {
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    return data;
  }
}
